import { render, staticRenderFns } from "./LaudoRenovabio.vue?vue&type=template&id=e88bc99c&scoped=true&lang=pug"
import script from "./LaudoRenovabio.vue?vue&type=script&lang=js"
export * from "./LaudoRenovabio.vue?vue&type=script&lang=js"
import style0 from "./LaudoRenovabio.vue?vue&type=style&index=0&id=e88bc99c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88bc99c",
  null
  
)

export default component.exports